export {
  Icon,
  IconSize,
  type IconName,
  type IconProps,
} from './Icon';
